interface TestEmailRequirements {
  logoUploaded: boolean;
  dkimVerified: boolean;
  returnPathVerified: boolean;
  forwardingConfirmed: boolean;
  sending: boolean;
}

export function getTestEmailDisabledReason({
  logoUploaded,
  dkimVerified,
  returnPathVerified,
  forwardingConfirmed,
  sending,
}: TestEmailRequirements): string | undefined {
  if (sending) {
    return "A test email is being sent. Please wait.";
  }

  const emailSetupComplete = dkimVerified && returnPathVerified && forwardingConfirmed;
  if (!emailSetupComplete) {
    return logoUploaded
      ? "Complete email forwarding setup to send a test email."
      : "Complete email forwarding setup and upload a company logo to send a test email.";
  }

  return logoUploaded ? undefined : "Upload a company logo to send a test email.";
}
